import { useUser } from "@js/apps/common/hooks";

export const useEmployerId = (): number | null => {
  const user = useUser();
  return user?.employer ?? null;
};
